import React, { useState, useEffect } from 'react';

import './what-are-content.scss';
import ContentHeader from '../../molecules/content-header/content-header';
import CrossMenu from '../../molecules/cross-menu/cross-menu';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import KeyEntry from '../../molecules/key-entry/key-entry';
import ShopCart from '../../molecules/shop-cart/shop-cart';
import FeaturedFooter from '../../molecules/featured-footer/featured-footer';
import SectionPointsInfo from '../../molecules/section-points-info/section-points-info';
import SectionWhatIsPoints from '../../molecules/section-what-is-points/section-what-is-points';
import SectionHowGet from '../../molecules/section-how-get/section-how-get';
import SectionRedeemPoints from '../../molecules/section-redeem-points/section-redeem-points';
import SectionWhenExpire from '../../molecules/section-when-expire/section-when-expire';
import SectionRedeemInfo from '../../molecules/section-redeem-info/section-redeem-info';
import EnvironmentalCard from '../../atoms/environmental-card/environmental-card';
import ModalKeyEntry from '../../molecules/modal-key-entry/modal-key-entry';
import SpanBanner from '../../atoms/span-banner/span-banner';
import FormatNumber from '../../../shared/utils/formatNumber'
import MyPointsService from "../../../shared/services/my-points-service";
import { siteUrl } from '../../../shared/utils/siteUrl';

const WhatAreContent = props => {

  const { mobile, setModalActive } = props;

  const myKeysDefault = '';
  const [myKeys, setMyKeys] = useState(myKeysDefault);
  const [keyLoader, setkeyLoader] = useState(false)
  const [showModalKey, setShowModalKey] = useState(false);
  const [valueInput, setValueInput] = useState(null);

  const bntLogOut =
    process.env.LOCALE === "es-UY" ?
      [
        {
          title: "¿Qué son?",
          slug: "/que-son"
        },
        {
          title: "Ingreso de claves",
          slug: "/ingreso-de-claves"
        }
      ]
      :
      [
        {
          title: "¿Qué son?",
          slug: "/que-son"
        },
        {
          title: "¿Qué puedo ganar?",
          slug: "/que-puedo-ganar"
        },
        {
          title: "Ingreso de claves",
          slug: "/ingreso-de-claves"
        }];

  const bntLogIn =
    process.env.LOCALE === "es-UY" ?
      [
        {
          title: "Mis movimientos",
          slug: "/mis-movimientos"
        },
        {
          title: "¿Qué son?",
          slug: "/que-son"
        },
      ]
      :
      [
        {
          title: "Mis movimientos",
          slug: "/mis-movimientos"
        },
        {
          title: "¿Qué son?",
          slug: "/que-son"
        },
        {
          title: "¿Qué puedo ganar?",
          slug: "/que-puedo-ganar"
        }];

  const [isLogIn, setIsLogIn] = useState(false);
  const [isRedeemInfo, setIsRedeemInfo] = useState(false);
  const [pageLoad, setpageLoad] = useState(false)
  const [keySubmit, setKeySubmit] = useState([])

  useEffect(() => {
    if (localStorage.getItem('USER_INFO'))
      setIsLogIn(localStorage.getItem("TOKEN_INFO"));

    setpageLoad(true)
  }, [])

  const loginRedirect = () => {
    if (typeof window !== 'undefined') {
      window.location.href = siteUrl + '/login'
    }
  }

  const getInfoProduct = (keyProduct) => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {

      setkeyLoader(true)
      let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      var config = {
        headers: {
          Authorization: tokenId
        },
      }

      let key = keyProduct.toUpperCase()

      const GenericIntimaWear = [
        "2T", "2S", "S2"
      ]

      const GenericBuenasNoches = [
        "LZ", "MC", "ZL", "H1", "NS"
      ]

      MyPointsService.getKeyProduct(key, config).then(res => {
        if (res.status === 400 || res.status === 404) {
          setKeySubmit(res)
          setkeyLoader(false)
        } else if (res.status === 200 && GenericIntimaWear.includes(res.data.generico) || GenericBuenasNoches.includes(res.data.generico)) {
          setShowModalKey(true);
          setkeyLoader(false);

        } else if (res.status === 200 && !GenericIntimaWear.includes(res.data.generico) || !GenericBuenasNoches.includes(res.data.generico)) {
          addKeys(keyProduct, '')
        }
      }).catch(err => console.log('Error:', err))

    }
  }

  const addKeys = (keyValue, codeValue) => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      // setkeyLoader(true)
      let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      var config = {
        headers: {
          Authorization: tokenId,
        },
      }

      let payload = {
        activity: '',
        // productGeneric: codeValue,
        key: {
          code: keyValue.toUpperCase()
        }
      }

      MyPointsService.postMyKeys(payload, codeValue, config).then(res => {
        if (res.status === 400 || res.status === 404) {
          setKeySubmit(res)
          setkeyLoader(false)
        } else if (res.status === 200) {
          // DataLayer
          try {
            window.dataLayer.push({
              'event': 'salesForcePush',
              'convid': 'null',
              'displayorder': 'null',
              'linkalias': 'Acumula Puntos',
              'amt': res.data.points,
              'unit': res.data.points
            });
          } catch (e) {
            console.log("Error", e);
          }

          setKeySubmit(res)
          userInfo.userPoints.pointsAccumulation += res.data.points
          localStorage.setItem('USER_INFO', JSON.stringify(userInfo));

          if (!mobile) {
            document.getElementById('points-user').innerHTML = FormatNumber(userInfo.userPoints.pointsAccumulation + userInfo.userPoints.pointsPresent) + ' PUNTOS'
          }
          setMyKeys(myKeysDefault)
          setkeyLoader(false)
          setShowModalKey(false)
          setValueInput(null)
        }
      }).catch(err => console.log(err))
    } else {
      sessionStorage.setItem('NEXT_PAGE', window.location.pathname);
      loginRedirect()
    }

  }

  return (
    <div className="f-what-are-content">

      <ContentHeader
        mobile={mobile}
      />

      {isLogIn &&
        <SpanBanner
          mobile={mobile} />
      }

      <div className="f-breadcrum-position">
        <Breadcrumb mobile={mobile} />
      </div>

      {pageLoad && !mobile &&
        <EnvironmentalCard 
          category="que_son"
        />
      }

      <CrossMenu
        mobile={mobile}
        btnOptions={isLogIn ? bntLogIn : bntLogOut}
        btnActiveDefault={isLogIn ? 1 : 0}
        isLogIn={isLogIn}
        category="que_son"
      />

      {
        process.env.LOCALE === "es-UY" ? null :
          <ShopCart
            mobile={mobile}
            isLogIn={isLogIn}
          />
      }

      <KeyEntry
        mobile={mobile}
        // addKeys={addKeys}
        getInfoProduct={getInfoProduct}
        setKeySubmit={setKeySubmit}
        keySubmit={keySubmit}
        myKeys={myKeys}
        setMyKeys={setMyKeys}
        isLogIn={isLogIn}
        keyLoader={keyLoader}
        category="que_son"
      />

      {pageLoad && <ModalKeyEntry
        showModalKey={showModalKey}
        setShowModalKey={setShowModalKey}
        valueInput={valueInput}
        setValueInput={setValueInput}
        addKeys={addKeys}
        myKeys={myKeys}
        keySubmit={keySubmit}
      />}

      {!isRedeemInfo ? <>

        <SectionWhatIsPoints
          mobile={mobile}
          isLogin={isLogIn}
          setModalActive={setModalActive}
          category="que_son"
        />

        <SectionHowGet
          mobile={mobile}
          setModalActive={setModalActive}
          isLogin={isLogIn}
          category="que_son"
        />

        {!isLogIn && process.env.LOCALE !== "es-UY" &&
          <SectionPointsInfo
            mobile={mobile}
          />
        }

        { process.env.LOCALE !== "es-UY" && <SectionRedeemPoints
          mobile={mobile}
          setIsRedeemInfo={setIsRedeemInfo}
          isLogin={isLogIn}
          category="que_son"
        />}

        <SectionWhenExpire
          mobile={mobile}
          isLogin={isLogIn}
        />

        <FeaturedFooter
          mobile={mobile}
          setModalActive={setModalActive}
          isLogin={isLogIn}
        />
      </> :
        <SectionRedeemInfo
          mobile={mobile}
          setIsRedeemInfo={setIsRedeemInfo}
          isLogin={isLogIn}
          category="que_son"
        />
      }

    </div>
  )
}

export default WhatAreContent;
